import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { OfferComment } from '@models/offer/offerComment.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class OfferCommentService {
  baseHref = `${environment.apiUrl}/offer-comments`;

  constructor(private http: HttpClient) {}

  createOfferComment(offerComment: OfferComment): Observable<OfferComment> {
    const url = `${this.baseHref}`;
    return this.http.post<any>(url, offerComment);
  }

  deleteComment(offerCommentId: number): Observable<any> {
    const url = `${this.baseHref}/${offerCommentId}`;
    return this.http.delete<any>(url);
  }

  editComment(data: any, offerCommentId: number): Observable<OfferComment> {
    const url = `${this.baseHref}/${offerCommentId}`;
    return this.http.put<OfferComment>(url, data);
  }
}
